import * as React from 'react'
import * as PropTypes from 'prop-types'
import moment from 'moment'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import { DatepickerMonth } from './datepicker-month'
import { Rule } from 'glamor'

interface IDatepickerProps {
  value?: string | moment.Moment
  onChange: (date: moment.Moment) => void
  firstSelectableDate?: moment.Moment
  lastSelectableDate?: moment.Moment
  style?: Rule
}

class DatepickerWithIntl extends React.Component<IDatepickerProps & WrappedComponentProps> {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    firstSelectableDate: PropTypes.object as any,
    lastSelectableDate: PropTypes.object as any,
    style: PropTypes.object,
    intl: PropTypes.object as any,
  }

  onDateSelected = (newDate: moment.Moment) => {
    this.props.onChange(newDate)
  }

  render() {
    const { value, firstSelectableDate, lastSelectableDate, style } = this.props
    const date = value ? moment(this.props.value) : null
    return (
      <DatepickerMonth
        firstSelectableDate={firstSelectableDate}
        isSingleMonth
        lastSelectableDate={lastSelectableDate}
        locale={this.props.intl.locale}
        onDateSelected={this.onDateSelected}
        style={style}
        timeperiod={{ fromDate: date, toDate: date }}
      />
    )
  }
}

export const Datepicker = injectIntl(DatepickerWithIntl)
